var weekStarterArray = [
    'sunday',
    'monday',
    '',
    '',
    '',
    '',
    'saturday',
];
export default weekStarterArray;
//# sourceMappingURL=weekStarterArray.js.map